/** Vocabulaire du domaine. Doit rester aligné sur les contraintes CHECK de supabase/schema.sql. */

export const STATUSES = ['prospect', 'conversion', 'client', 'gratuit']

/**
 * Les clés ('conversion', 'gratuit') sont figées : elles sont écrites en base
 * et contraintes par un CHECK dans supabase/schema.sql. Seuls les libellés
 * changent — les renommer coûterait une migration pour un gain nul.
 */
export const STATUS_LABELS = {
  prospect: 'Prospect',
  conversion: 'Négociation',
  client: 'Client',
  gratuit: 'Partenaire',
}

export const STATUS_LABELS_PLURAL = {
  prospect: 'Prospects',
  conversion: 'Négociations',
  client: 'Clients',
  gratuit: 'Partenaires',
}

export const STATUS_COLORS = {
  prospect: '#dc2626', // rouge
  conversion: '#eab308', // jaune
  client: '#059669', // émeraude
  gratuit: '#7c3aed', // violet
}

/**
 * La couleur de l'argent est celle du client.
 *
 * Le vert ne décore pas : il désigne. Un montant est du revenu, le revenu vient
 * des clients, et les clients sont verts sur la carte. Employer une autre teinte
 * pour les montants — l'or d'autrefois — laissait croire à une catégorie de
 * plus.
 */
export const MONEY_COLOR = STATUS_COLORS.client

/**
 * Contour des marqueurs ronds. Blanc par défaut, sauf là où il disparaîtrait :
 * sur le fond clair de la carte (#f5f5f3), un jaune cerné de blanc n'a plus de
 * silhouette. Les teintes foncées ci-dessous sont les mêmes couleurs, assombries.
 */
export const STATUS_STROKES = {
  conversion: '#a16207',
  client: '#046c4e',
  gratuit: '#5b21b6',
}

export const KINDS = ['gmf', 'hosp']
export const TYPES = ['gmf', 'gmfu', 'hosp']

/**
 * Au premier lancement, seuls les prospects s'affichent.
 *
 * C'est l'état de travail : on ouvre l'outil pour démarcher, pas pour
 * contempler ses clients acquis. Les 813 prospects sont le gisement ; les
 * trois autres statuts se consultent à la demande.
 */
export const DEFAULT_STATUS_FILTERS = {
  prospect: true,
  conversion: false,
  client: false,
  gratuit: false,
}

/**
 * Patients inscrits par professionnel, pour estimer l'effectif d'un GMF.
 * Calé sur un cas réel — GMF Laframboise, ~17 560 inscrits pour 50
 * professionnels — et réglable dans l'app. Un ordre de grandeur, pas une
 * mesure : toute saisie manuelle le supplante.
 */
export const DEFAULT_RATIO_PRO = 350

export const DEFAULT_SETTINGS = { tarif: 0, ratioPro: DEFAULT_RATIO_PRO }

